import React from 'react'
import { Link, NavLink } from "react-router-dom";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import team1 from '../../assets/Images/team-slider1.png'
import team2 from '../../assets/Images/team-slider2.png'
import team3 from '../../assets/Images/team-slider3.png'
import team4 from '../../assets/Images/team-slider4.png'
import abd from '../../assets/Images/abd.jpeg'

import { FaFacebookF } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";

function OurTeam() {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        arrows: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 1,
                },
            },
        ],
    };
    return (
        <>
            <div className="container">
                <div className="port2">
                    <div className="container" style={{ padding: '0' }}>
                        <div className="row align-items-center">
                            <div className="col-lg-8 col-md-8 col-sm-12 col-12 d-flex flex-column justify-content-md-start justify-conten-sm-center justify-content-center">
                                <div className="d-flex gap-3 align-items-center justify-content-md-start justify-conten-sm-center justify-content-center">
                                    <hr className='hr3' />
                                    <h3 className='heading1 m-0'>Our Team</h3>
                                </div>
                                <h2 style={{ padding: '0 212px 0 0' }}>
                                    Meet Our Team of Professionals
                                </h2>
                                <p style={{ padding: '0 221px 0 0 ' }}>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever.
                                </p>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-12 col-12 d-flex align-items-center justify-content-center">
                                <Link to = "/team" className="btn_2" style={{ border: '1px solid #FF7627' }}>All Members</Link>
                            </div>
                        </div>
                    </div>
                </div> {/* data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1400" */}
                <div className="team-slider mt-5"> {/* data-aos="zoom-in" data-aos-easing="ease" data-aos-duration="1700" */}
                    <Slider {...settings}>
                        <div className="team-img d-flex align-items-center">
                            <img src={team1} alt="team1.img" />
                            <div className="overlay">
                                <div className="overlay-text text-center">
                                    <h3>Jane Doe</h3>
                                    <h4>Designer</h4>
                                    <div className="d-flex align-items-center justify-content-center gap-3">
                                        <a href="https://web.facebook.com/NexelisTechnologies" target="blank"><FaFacebookF /></a>
                                        <a href="#"><FaWhatsapp /></a>
                                        <a href="https://www.instagram.com/nexelistechnologies/" target="blank"><FaInstagram /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="team-img d-flex align-items-center">
                            <img src={team2} alt="team1.img" />
                            <div className="overlay">
                                <div className="overlay-text text-center">
                                    <h3>Kaitti Pairi</h3>
                                    <h4>Seo Expert</h4>
                                    <div className="d-flex align-items-center justify-content-center gap-3">
                                        <a href="https://web.facebook.com/NexelisTechnologies" target="blank"><FaFacebookF /></a>
                                        <a href="#"><FaWhatsapp /></a>
                                        <a href="https://www.instagram.com/nexelistechnologies/" target="blank"><FaInstagram /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="team-img d-flex align-items-center">
                            <img src={team3} alt="team1.img" />
                            <div className="overlay">
                                <div className="overlay-text text-center">
                                    <h3>Jonny coll</h3>
                                    <h4>Developer</h4>
                                    <div className="d-flex align-items-center justify-content-center gap-3">
                                        <a href="https://web.facebook.com/NexelisTechnologies" target="blank"><FaFacebookF /></a>
                                        <a href="#"><FaWhatsapp /></a>
                                        <a href="https://www.instagram.com/nexelistechnologies/" target="blank"><FaInstagram /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="team-img d-flex align-items-center">
                            <img src={team4} alt="team1.img" />
                            <div className="overlay">
                                <div className="overlay-text text-center">
                                    <h3>Anni Doe</h3>
                                    <h4>UI/UX</h4>
                                    <div className="d-flex align-items-center justify-content-center gap-3">
                                        <a href="https://web.facebook.com/NexelisTechnologies" target="blank"><FaFacebookF /></a>
                                        <a href="#"><FaWhatsapp /></a>
                                        <a href="https://www.instagram.com/nexelistechnologies/" target="blank"><FaInstagram /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="team-img d-flex align-items-center">
                            <img src={team1} alt="team1.img" />
                            <div className="overlay">
                                <div className="overlay-text text-center">
                                    <h3>Jane Doe</h3>
                                    <h4>Designer</h4>
                                    <div className="d-flex align-items-center justify-content-center gap-3">
                                        <a href="https://web.facebook.com/NexelisTechnologies" target="blank"><FaFacebookF /></a>
                                        <a href="#"><FaWhatsapp /></a>
                                        <a href="https://www.instagram.com/nexelistechnologies/" target="blank"><FaInstagram /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Slider>
                </div>
            </div>
            <div className="team-btn"> {/* data-aos="zoom-in" data-aos-easing="ease" data-aos-duration="1900" */}
                <div className="container d-flex align-items-center justify-content-between justify-content-md-center justify-content-sm-center justify-content-center gap-4 text-center flex-wrap">
                    <h3 className='m-0'>Ask a Question to our Team, and get, Response Quickly</h3>
                    <Link to ="/Contact" className="btn_2 " style={{ border: '1px solid #FF7627' }} >Contact Now</Link>
                </div>
            </div>
        </>
    )
}

export default OurTeam
